<app-node-path [nodePath]="nodePath$ | async"></app-node-path>

<q9-page-loader [isLoading]="!rootData || (loading$ | async)"></q9-page-loader>

<kendo-treelist
  #treeList
  class="rm-tree-list"
  [data]="sourceData$ | async"
  [fetchChildren]="fetchChildNodes"
  [hasChildren]="hasChildren"
  idField="id"
  parentIdField="parentId"
  [selectable]="selectableConfig"
  [isSelected]="isSelected"
  [virtualColumns]="true"
  kendoTreeListExpandable
  [(expandedKeys)]="expandedKeys"
  itemKey="id"
  (expand)="onExpandChange($event)"
  (collapse)="onExpandChange($event)"
  (cellClick)="onCellClick($event)"
  (selectionChange)="handleSelectionChange($event)">
  <ng-container *ngFor="let column of columns">
    <kendo-treelist-column
      [field]="column.field"
      [title]="column.title"
      [expandable]="column.expandable"
      [hidden]="column.hidden"
      [width]="column.width"
      [minResizableWidth]="column.width">
      <ng-template kendoTreeListCellTemplate let-dataItem let-rowIndex="rowIndex">
        <ng-container
          *ngFor="
            let item of column.field === 'tags'
              ? (dataItem | gridColumnCell: column)
              : [dataItem | gridColumnCell: column]
          ">
          <span [ngClass]="column | gridColumnClass: dataItem">{{ item | translate }}</span>

          <ng-container *ngIf="column.field === 'name' && dataItem.description">
            <span class="secondary-grid-text node-description" [title]="dataItem.description">
              {{ dataItem.description }}
            </span>
          </ng-container>
        </ng-container>
      </ng-template>
    </kendo-treelist-column>
  </ng-container>
</kendo-treelist>

<q9-context-menu
  *ngIf="treeList"
  #contextMenu
  [menuItems]="menuItems"
  [selectedRows]="selectedGridNodes"
  [target]="treeList"></q9-context-menu>
